export default "__VITE_ASSET__Nb38ihmq__"